import { SxProps, Box, Typography } from "@mui/material"

interface IInfoItemProps {
  sx: SxProps
  primary: React.ReactNode
  secondary?: string
  title: string
}

export const InfoItem: React.FC<IInfoItemProps> = ({
  sx,
  primary,
  secondary,
  title,
}) => {
  return (
    <Box sx={sx}>
      <Typography className="InfoItem-title">{title}</Typography>
      <Typography className="InfoItem-primary">
        {primary} {secondary && `| ${secondary}`}
      </Typography>
    </Box>
  )
}
